// API endpoints
export const COMPANIONS_API = {
    TRIPS: '/companions/trips/',
    MY_TRIPS: '/companions/my-trips/',
    MY_REQUESTS: '/companions/my-requests/',
    tripDetail: (id) => `/companions/trips/${id}/`,
    tripApply: (id) => `/companions/trips/${id}/apply/`,
    tripCandidates: (id) => `/companions/trips/${id}/candidates/`,
    requestAction: (id) => `/companions/requests/${id}/action/`,
    requestCancel: (id) => `/companions/requests/${id}/cancel/`,
    tripMessages: (tripId) => `/companions/trips/${tripId}/messages/`,
};

// Request status configuration
export const REQUEST_STATUS = {
    pending: {
        label: 'На рассмотрении',
        color: '#f59e0b', // amber
        icon: 'fa-clock',
        emoji: '🟡',
    },
    approved: {
        label: 'Принят',
        color: '#22c55e', // green
        icon: 'fa-check-circle',
        emoji: '🟢',
    },
    rejected: {
        label: 'Отклонен',
        color: '#ef4444', // red
        icon: 'fa-times-circle',
        emoji: '🔴',
    },
    canceled: {
        label: 'Отменен',
        color: '#6b7280', // gray
        icon: 'fa-ban',
        emoji: '⚫',
    },
    removed: {
        label: 'Удален из поездки',
        color: '#dc2626', // red
        icon: 'fa-user-times',
        emoji: '🚫',
    },
};

// Safety disclaimer text
export const SAFETY_DISCLAIMER = {
    title: 'Правила безопасности',
    warnings: [
        {
            icon: 'fa-link',
            text: 'Не переходите по ссылкам из чата',
        },
        {
            icon: 'fa-credit-card',
            text: 'Не переводите деньги незнакомцам',
        },
        {
            icon: 'fa-comments',
            text: 'Не переходите в сторонние мессенджеры',
        },
    ],
};

// Feed tabs
export const FEED_TABS = {
    POSTS: 'posts',
    COMPANIONS: 'companions',
};

// Profile tabs
export const PROFILE_TABS = {
    POSTS: 'posts',
    TRIPS: 'trips',
    ARCHIVE: 'archive',
};

// Trips sub-tabs in profile
export const TRIPS_SUB_TABS = {
    ORGANIZER: 'organizer', // Я Организатор
    PASSENGER: 'passenger', // Я Пассажир
};
